(() => {
  'use strict';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 720px)');
  const clamp = x => Math.max(0, Math.min(1, x));
  const lerp = (a,b,t) => a+(b-a)*t;
  let frame=0, lastTime=0;
  const scenes=new Map();
  const isPaused=()=>reduce.matches||document.documentElement.classList.contains('motion-paused');
  // Renderer contract: render(progress, viewport), dispose(). A future validated
  // GLB renderer can replace this photo renderer without changing the scroll driver.
  function photoRenderer(section) {
    const stage=section.querySelector('.experience-stage');
    const copies=[...section.querySelectorAll('[data-scene-copy]')];
    const buttons=[...section.querySelectorAll('[data-scene]')];
    const count=section.querySelector('[data-scene-count]');
    const pin=section.querySelector('[data-pin]');
    let lastIndex=-1;
    return {
      render(p) {
        const frames=mobile.matches?
          [[0,0,-9,1],[16,17,8,1.35],[-24,-21,-12,1.55]]:
          [[-2,0,-7,.94],[14,17,9,1.32],[-27,-28,-15,1.58]];
        const segment=p<.5?0:1;
        const t=clamp((p-segment*.5)*2);
        const eased=t*t*(3-2*t);
        const values=frames[segment].map((v,i)=>lerp(v,frames[segment+1][i],eased));
        ['x','y','r','s'].forEach((key,i)=>stage.style.setProperty('--plane-'+key,values[i].toFixed(4)));
        stage.style.setProperty('--scene-p',p.toFixed(5));
        const index=p<.28?0:p<.73?1:2;
        if(index!==lastIndex){
          lastIndex=index;
          copies.forEach((copy,i)=>{copy.classList.toggle('is-current',i===index);});
          buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
          count.textContent=String(index+1).padStart(2,'0');
          pin.style.left=index===1?'31%':'61%';pin.style.top=index===1?'33%':'60%';
          pin.style.opacity=index===0?'0':'1';
        }
      },
      dispose(){stage.style.removeProperty('--scene-p');}
    };
  }
  function draw(now) {
    frame=0;
    const delta=Math.min(48,now-(lastTime||now));lastTime=now;
    let more=false;
    scenes.forEach(state=>{
      if(isPaused()||document.hidden){stopDemo(state);return;}
      if(state.demoStart!==null){
        const p=clamp((now-state.demoStart)/8500);
        state.target=p;
        if(p>=1)stopDemo(state);else more=true;
      }
      const difference=state.target-state.current;
      if(Math.abs(difference)>.0003){state.current+=difference*(1-Math.exp(-delta/90));more=true;}
      else state.current=state.target;
      state.renderer.render(state.current);
    });
    if(more)frame=requestAnimationFrame(draw);
  }
  const schedule=()=>{if(!frame){lastTime=0;frame=requestAnimationFrame(draw);}};
  function stopDemo(state){state.demoStart=null;state.button.setAttribute('aria-pressed','false');state.button.innerHTML='Ver recorrido <span>↗</span>';}
  function updateScroll(){
    if(isPaused())return;
    scenes.forEach((state,section)=>{
      if(state.manual||state.demoStart!==null)return;
      const rect=section.getBoundingClientRect();
      state.target=clamp(-rect.top/Math.max(1,rect.height-innerHeight));
    });
    const hero=document.querySelector('[data-hero]');
    if(hero){const rect=hero.getBoundingClientRect();hero.style.setProperty('--hero-p',clamp(-rect.top/rect.height).toFixed(4));}
    schedule();
  }
  function resumeScroll(){scenes.forEach(s=>{s.manual=false;stopDemo(s);});updateScroll();}
  function init(root=document){
    root.querySelectorAll('[data-experience]').forEach(section=>{
      if(scenes.has(section))return;
      const state={current:0,target:0,manual:false,demoStart:null,renderer:photoRenderer(section),button:section.querySelector('[data-demo]')};
      scenes.set(section,state);state.renderer.render(0);
      section.querySelectorAll('[data-scene]').forEach(button=>button.addEventListener('click',()=>{
        if(isPaused())return;
        stopDemo(state);state.manual=true;state.target=Number(button.dataset.scene)/2;schedule();
      }));
      state.button.addEventListener('click',()=>{
        if(isPaused())return;
        if(state.demoStart!==null){stopDemo(state);return;}
        state.manual=true;state.current=0;state.target=0;state.demoStart=performance.now();
        state.button.setAttribute('aria-pressed','true');state.button.innerHTML='Pausar recorrido <span>Ⅱ</span>';schedule();
      });
    });
    updateScroll();
  }
  document.addEventListener('click',event=>{
    const level=event.target.closest('[data-level]');if(!level)return;
    const n=Number(level.dataset.level);
    level.closest('.temperature-instrument')?.querySelectorAll('.heat-meter i').forEach((bar,i)=>{
      bar.style.background=i<n?'var(--darkrose)':'var(--line)';bar.style.scale=i<n?'1 1':'1 .55';
    });
  });
  const motionObserver=new MutationObserver(()=>{if(isPaused())scenes.forEach(stopDemo);else updateScroll();});
  motionObserver.observe(document.documentElement,{attributes:true,attributeFilter:['class']});
  // Observe the unclipped parent. Observing a fully clipped heading can report
  // zero intersection forever and leave the text invisible.
  const reveal=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.querySelectorAll('.reveal-heading').forEach(h=>h.classList.add('is-revealed'));reveal.unobserve(e.target);}}),{threshold:.1});
  document.querySelectorAll('.chapter-v3 h2,.temperature h2,.editorial-copy h2,.detail-gallery-title h2,.films h2,.final-product h2').forEach(heading=>{heading.classList.add('reveal-heading');reveal.observe(heading.parentElement);});
  document.documentElement.classList.add('motion-ready');
  addEventListener('scroll',updateScroll,{passive:true});addEventListener('resize',updateScroll,{passive:true});
  addEventListener('wheel',resumeScroll,{passive:true});addEventListener('touchstart',resumeScroll,{passive:true});
  addEventListener('keydown',event=>{if(['PageDown','PageUp','Home','End','ArrowDown','ArrowUp',' '].includes(event.key)&&!['INPUT','TEXTAREA'].includes(event.target.tagName)&&!(event.key===' '&&event.target.tagName==='BUTTON'))resumeScroll();});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)scenes.forEach(stopDemo);else updateScroll();});
  reduce.addEventListener('change',()=>{scenes.forEach(stopDemo);updateScroll();});
  mobile.addEventListener('change',()=>{scenes.forEach(s=>s.renderer.render(s.current));updateScroll();});
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{scenes.forEach((s,section)=>{if(event.target.contains(section)){stopDemo(s);s.renderer.dispose();scenes.delete(section);}});});
  init();
})();
